import getApiClient from '@/plugins/api-client'

export default {
  load () {
    const api = getApiClient(this.$store)

    api.get('redirects')
      .then(result => {
        this.redirects = result.data['hydra:member']
      })
      .catch(error => {
        this.error = error
      })
  },

  askDelete (id) {
    this.showDeleteDialog = true
    this.deletingId = id
  },

  cancelDelete () {
    this.showDeleteDialog = false
    this.deletingId = null
  },

  confirmDelete () {
    if (!this.deletingId) {
      return
    }

    const api = getApiClient(this.$store)

    api.delete(this.deletingId)
      .then(result => {
        if (result.status === 204) {
          this.$store.commit('app/raiseSuccess', 'Redirecionamento excluído')
          this.load()
        }
      })
      .catch(() => {
        this.$store.commit('app/raiseError', 'Erro ao excluir redirecionamento')
        this.load()
      })
      .finally(() => {
        this.cancelDelete()
      })
  },
}
